import { px } from "@/components/tool-kit/charts/marks";
import { Arrow, TextLines } from "@/components/tool-kit/diagrams/svg-parts";
import { LINE_HEIGHT, type Rect } from "@/lib/tool-kit/charts/layout";
import { CHART_INK } from "@/lib/tool-kit/palette";

/*
 * The connectors of a layered diagram: orthogonal arrows, drawn before the boxes so the
 * boxes sit on top, and the labels drawn last on small white plates so the line behind
 * them never runs through the words.
 */

export interface DrawnEdge {
  key: string;
  points: readonly [number, number][];
  dashed?: boolean;
}

export interface DrawnLabel {
  key: string;
  rect: Rect;
  /** One entry per line of the label. */
  lines: readonly string[];
}

export function LayeredArrows({
  edges,
  color = CHART_INK.text,
  width = 1.4,
}: {
  edges: readonly DrawnEdge[];
  color?: string;
  width?: number;
}) {
  return (
    <g>
      {edges.map((edge) => (
        <Arrow
          color={color}
          dashed={edge.dashed}
          key={edge.key}
          points={edge.points}
          width={width}
        />
      ))}
    </g>
  );
}

export function LayeredLabels({
  labels,
  fontSize,
  bold = false,
}: {
  labels: readonly DrawnLabel[];
  fontSize: number;
  bold?: boolean;
}) {
  return (
    <g>
      {labels.map((label) => (
        <g key={label.key}>
          <rect
            fill={CHART_INK.background}
            height={px(label.rect.height)}
            rx={4}
            width={px(label.rect.width)}
            x={px(label.rect.x)}
            y={px(label.rect.y)}
          />
          <TextLines
            bold={bold}
            fill={CHART_INK.text}
            fontSize={fontSize}
            lineHeight={fontSize * LINE_HEIGHT}
            lines={label.lines}
            top={
              label.rect.y +
              (label.rect.height -
                label.lines.length * fontSize * LINE_HEIGHT) /
                2
            }
            x={label.rect.x + label.rect.width / 2}
          />
        </g>
      ))}
    </g>
  );
}
